import { store } from '../store'
import http from '../api/api'
import config from '../api/constants'

const getFeedbackComplaintCategory = async () => {
  try {
    const { app } = store.getState()
    const reqParams = {
      requestId: 'FEEDBACK',
    }
    const response = await http.post(config.apiRoute.GET_FEEDBACK_COMPLAINT_CATEGORY, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const saveFeedback = async ({
  category,
  suggestion,
}) => {
  try {
    const { app } = store.getState()
    const reqParams = {
      emailId: app.profile.emailId,
      requestId: 'FEEDBACK',
      category: category,
      categoryEmail: app.profile.emailId,
      suggestion: suggestion,
    }
    const response = await http.post(config.apiRoute.ADD_FEEDBACK, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const FeedbackService = {
  getFeedbackComplaintCategory,
  saveFeedback
}

export default FeedbackService